import request from '@shared/utils/request'
//获取用户菜单
export function getUserInfo(data) {
  return request({
    url: '/sys-user/userInfo',
    method: 'post',
    data
  })
}
//修改密码
export function updatePassword(data) {
  return request({
    url: '/sys-user/updatePassWord',
    method: 'post',
    data
  })
}

export function getListByRole(data) {
  return request({
    url: '/sys-user/listByRole',
    method: 'post',
    data
  })
}

/** 查询用户的数据权限 */
export function getPipeScope(params) {
  return request({
    url: '/sys-user/getPipeScope',
    method: 'post',
    params
  })
}

/** 查询用户的污水厂权限 */
export function getFactoryScope(params) {
  return request({
    url: '/sys-user/getFactoryScope',
    method: 'post',
    params
  })
}

export function getComplexPipelineScope(params) {
  return request({
    url: '/sys-user/getComplexPipelineScope',
    method: 'post',
    params
  })
}
